module.exports = __webpack_public_path__ + "img/28.216f673b.jpg";